function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { createContext, useEffect, useState } from 'react';
import { LoadingOverlay, Modal, ModalBody, ModalHeader } from '@deephaven/components';
import Log from '@deephaven/log';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('@deephaven/jsapi-bootstrap.ApiBootstrap');
export var ApiContext = /*#__PURE__*/createContext(null);
ApiContext.displayName = 'ApiContext';
/**
 * ApiBootstrap loads the API from the provided URL, rendering the children once loaded.
 */
export function ApiBootstrap(_ref) {
  var apiUrl = _ref.apiUrl,
    children = _ref.children,
    failureElement = _ref.failureElement,
    _ref$setGlobally = _ref.setGlobally,
    setGlobally = _ref$setGlobally === void 0 ? false : _ref$setGlobally;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    api = _useState4[0],
    setApi = _useState4[1];
  useEffect(() => {
    function loadApi() {
      return _loadApi.apply(this, arguments);
    }
    function _loadApi() {
      _loadApi = _asyncToGenerator(function* () {
        try {
          var dh =
          // Ignore the warning about dynamic import in both Vite and Webpack.
          // We use Vite, but some clients may use Webpack.
          (yield import(/* @vite-ignore */ /* webpackIgnore: true */apiUrl)).default;
          log.info('API bootstrapped from', apiUrl);
          setApi(dh);
          if (setGlobally) {
            log.debug('API set globally');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            globalThis.dh = dh;
          }
        } catch (e) {
          log.error('Unable to bootstrap API', e);
        }
        setIsLoading(false);
      });
      return _loadApi.apply(this, arguments);
    }
    loadApi();
  }, [apiUrl, setGlobally]);
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      "data-testid": "api-bootstrap-loading"
    });
  }
  if (api == null) {
    return failureElement !== null && failureElement !== void 0 ? failureElement : /*#__PURE__*/_jsxs(Modal, {
      isOpen: true,
      className: "modal-dialog-centered",
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        closeButton: false,
        children: "Error: Unable to load API"
      }), /*#__PURE__*/_jsx(ModalBody, {
        children: /*#__PURE__*/_jsxs("p", {
          className: "text-break",
          children: ["Ensure the server is running and you are able to reach ", apiUrl, ", then refresh the page."]
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(ApiContext.Provider, {
    value: api,
    children: children
  });
}
export default ApiBootstrap;
//# sourceMappingURL=ApiBootstrap.js.map